import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Typography, useTheme, Box } from "@mui/material";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import { i18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";
import { logout } from "../../store/auth.tsx";
import { fetchExamples } from "../../store/example.tsx";
import type { RootState } from "../../store/types.tsx";

interface LogoutDrawerActionProps {
  closeDrawer: () => void;
}

const LogoutDrawerAction: React.FC<LogoutDrawerActionProps> = ({
  closeDrawer,
}) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isLoggedIn = useSelector(
    (state: RootState) => state.authState.isLoggedIn,
  );

  const handleLogout = () => {
    closeDrawer();
    dispatch(logout());
    dispatch({ type: "RESET_STATE" });
    dispatch(fetchExamples({ isLoggedIn: false }) as any);
  };

  if (!isLoggedIn) {
    return null;
  }

  return (
    <Typography
      variant="h4"
      onClick={handleLogout}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
        cursor: "pointer",
        whiteSpace: "nowrap",
        fontSize: "1rem !important",
        width: "100%",
        lineHeight: "1",
        margin: "0",
        py: "6px",
        color: theme.palette.common.black,
        fontWeight: 500,
        borderRadius: "25px",
        transition: "background-color 0.15s ease, color 0.15s ease",
        "&:hover": {
          backgroundColor: theme.palette.action.hover,
          color: theme.palette.common.black,
        },
      }}
    >
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: "20px",
          height: "20px",
        }}
      >
        <LogoutRoundedIcon sx={{ fontSize: 20 }} />
      </Box>
      <Box
        component="span"
        sx={{
          display: "inline-flex",
          alignItems: "left",
        }}
      >
        {i18n._(
          msg({ message: "Logout", context: "Action to logout the user" }),
        )}
      </Box>
    </Typography>
  );
};

export default LogoutDrawerAction;
